
import { useTranslation } from 'react-i18next';

const LocationInfo = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            {t('location.title')}
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto px-4">
            {t('location.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-lg sm:text-xl text-black"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Adresse</h3>
                <p className="text-sm sm:text-base text-gray-600">{t('location.address')}</p>
              </div>
            </div>

            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-lg sm:text-xl text-black"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Horaires</h3>
                <p className="text-sm sm:text-base text-gray-600">{t('location.hours')}</p>
              </div>
            </div>

            <div className="flex items-start space-x-3 sm:space-x-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-lg sm:text-xl text-black"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Téléphones</h3>
                <div className="space-y-1">
                  <p className="text-sm sm:text-base text-gray-600">+237 693 695 377</p>
                  <p className="text-sm sm:text-base text-gray-600">+237 695 047 961</p>
                  <p className="text-sm sm:text-base text-gray-600">+237 671 954 603</p>
                </div>
              </div>
            </div>

            <a
              href="https://maps.google.com/?q=Rhône-Poulenc,Douala,Cameroon"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-black text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-navigation-line"></i>
              <span>{t('location.directions')}</span>
            </a>
          </div>

          <div className="relative">
            <div className="bg-gray-200 rounded-2xl overflow-hidden shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=Rhône-Poulenc,Douala,Cameroon&zoom=15"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="NPA Location Map - Rhône-Poulenc, Douala"
                className="sm:h-96 lg:h-[400px]"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationInfo;
